<template>
    <OrderCheckNav />
    <OrderCheckBody @paymentStep="updateStep" />
</template>

<script>
import OrderCheckNav from './OrderCheckNav';
import OrderCheckBody from './OrderCheckBody';

export default {
    components: {
        OrderCheckNav,
        OrderCheckBody,
    },
    methods: {
        updateStep(stepIndex) {
            this.$emit("paymentStep", stepIndex);
        }
    },
}
</script>